import { Navigate } from 'react-router-dom';
import { useAuth } from '../shared/context/AuthContext';
import { useEntitlements } from '../shared/hooks/useEntitlements';
import type { FeatureKey } from '../shared/services/entitlementsService';
import { getHomePath } from '../shared/utils/homePath';

/**
 * Ruta de una funcionalidad del paquete (feature-106, F8): mientras carga no
 * pinta nada y, si no está en el paquete, lleva a la home. Es solo interfaz:
 * el backend responde 403 igualmente.
 */
export function FeatureRoute({ feature, children }: { feature: FeatureKey; children: React.ReactNode }) {
  const { user } = useAuth();
  const { features, has } = useEntitlements();
  if (features === null) return null;
  if (!has(feature)) return <Navigate to={getHomePath(user?.role)} replace />;
  return <>{children}</>;
}
